import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { NavigationService } from '../services/navigation/navigation.service';

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated } = authData;
    const router = inject(Router);
    const navigationService = inject(NavigationService);

    // If the user is not authenticated...
    if (!authenticated) {
        // Store the desired redirect URL for after authentication
        if (state.url !== '/sign-out') {
            navigationService.storeRedirectUrl(state.url);
        }
        
        // Redirect to the login page (Keycloak will handle the actual authentication)
        return router.parseUrl('/sign-in');
    }

    // User is authenticated, allow access
    return true;
};

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
export const AuthChildGuard = createAuthGuard<CanActivateChildFn>(isAccessAllowed);
